import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { AuthServiceService } from '../../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../../../shareModule/services/shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { YoutubeIframesComponent } from 'src/app/youtube-iframes/youtube-iframes.component';
import { CommonService } from '../../../../shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

@Component({
    selector: 'app-common-product-change-tag',
    templateUrl: './common-product-change-tag.component.html',
    styleUrls: ['./common-product-change-tag.component.scss']
})
export class CommonProductChangeTagComponent implements OnInit {
    @Input() product: any = {};
    @Output() tagChanged = new EventEmitter<any>();
    @Output() modalClosed = new EventEmitter<void>();

   
    public verifiedTagOptions = ['Verified', 'Quality', 'Value', 'Unique', 'Preferred', 'Top Seller', 'Chain', ''];
    public additionalTagOptions = ['Must Try', 'Human Icon', 'Star', 'Youtube', 'Affordable', 'Hidden Gem'];
    public sanitizedYoutubeIframes = [];

    // Map Tag properties
    public mapTags: string[] = [];
    public mapUserTags: string[] = [];

    // Tag list from API
    public tagGroups: any[] = [];
    public tagGroupsUser: any[] = [];
    public loadingTags = false;

    // Business Map Tag options
    public staticMapTagOptions = [
        'Restaurant',
        'Cafe',
        'Food Court',
        'Hawker Center',
        'Fast Food',
        'Fine Dining',
        'Casual Dining',
        'Takeaway',
        'Delivery',
        'Grocery Store',
        'Supermarket',
        'Convenience Store',
        'Pharmacy',
        'Clinic',
        'Hospital',
        'Bank',
        'ATM',
        'Shopping Mall',
        'Retail Store',
        'Beauty Salon',
        'Barber Shop',
        'Gym',
        'Fitness Center',
        'Park',
        'Playground',
        'School',
        'University',
        'Library',
        'Museum',
        'Cinema',
        'Theater',
        'Hotel',
        'Hostel',
        'Gas Station',
        'Car Wash',
        'Auto Repair',
        'Public Transport',
        'Bus Stop',
        'MRT Station',
        'Taxi Stand'
    ];

    // User Map Tag options (more personal/lifestyle focused)
    public staticMapUserTagOptions = [
        'My Favorite',
        'Frequent Visit',
        'Date Night',
        'Family Spot',
        'Work Lunch',
        'Quick Bite',
        'Special Occasion',
        'Hidden Gem',
        'Local Favorite',
        'Must Try',
        'Budget Friendly',
        'Luxury Dining',
        'Healthy Option',
        'Late Night',
        'Weekend Brunch',
        'Coffee Break',
        'Study Spot',
        'Meeting Place',
        'Photo Worthy',
        'Pet Friendly',
        'Kid Friendly',
        'Romantic',
        'Group Hangout',
        'Solo Dining',
        'Takeaway Only',
        'Dine In Only',
        'Outdoor Seating',
        'Indoor Only',
        'Parking Available',
        'Public Transport',
        'Walking Distance',
        'Wheelchair Accessible'
    ];

    constructor(
        private auth: AuthServiceService,
        private toastr: ToastrService,
        private sharedService: SharedService,
        private modalService: NgbModal,
        private commonService: CommonService,
        private customerService: CustomerService
    ) { }

    ngOnInit(): void {
        this.additionalTags = new Set((this.product?.additionalTag?.trim() ?? '').split(','));
        console.log("additionalTags", this.additionalTags)
        // Handle mapTag as array or string for backward compatibility
        this.mapTags = this._parseMapTag(this.product?.mapTag);
        // Handle mapUserTag as array or string for backward compatibility
        this.mapUserTags = this._parseMapTag(this.product?.mapUserTag);
        this._sanitizeYoutubeIframes();
        this._getTagList();
    }


    // Map Tag selection methods
    public toggleMapTag(tag: string): void {
        const index = this.mapTags.indexOf(tag);
        if (index > -1) {
            // Remove tag if already selected
            this.mapTags.splice(index, 1);
        } else {
            // Add tag if not selected
            this.mapTags.push(tag);
        }
        this._changeProductProperty('mapTag', this.mapTags, true);
    }

    public isMapTagSelected(tag: string): boolean {
        return this.mapTags.includes(tag);
    }

    // Map User Tag selection methods
    public toggleMapUserTag(tag: string): void {
        const index = this.mapUserTags.indexOf(tag);
        if (index > -1) {
            // Remove tag if already selected
            this.mapUserTags.splice(index, 1);
        } else {
            // Add tag if not selected
            this.mapUserTags.push(tag);
        }
        this._changeProductProperty('mapUserTag', this.mapUserTags);
    }

    public isMapUserTagSelected(tag: string): boolean {
        return this.mapUserTags.includes(tag);
    }

    public setHoverLink(event: any): void {
        const value = event.target.value;
        this._changeProductProperty('linked', value);
    }

    public additionalTags = new Set<string>()

    public updateAdditionalTags(): void {

        //this.additionalTag = value?.trim()?.toLowerCase() || '';
        const newAdditionalTag = Array.from(this.additionalTags).join(',')
        this._changeProductProperty('additionalTag', newAdditionalTag);
     
    }

    public setCustomBookButton(event){
        const value = event.target.value;
        this._changeProductProperty("customBookButton", value)
    }

    public setVerifiedTag(event: any): void {
        const value = event.target.value;
        this._changeProductProperty('verifiedTag', value);
    }
    
    public setBonus(event: any) : void{
        const value = event.target.value;
        this._changeProductProperty("bookingPercentOff", value)
    }
    public openYoutubeIframes(): void {
        const ref = this.modalService.open(YoutubeIframesComponent, { size: 'md' });
        ref.componentInstance.iframes = this.sanitizedYoutubeIframes;
    }

    public closeModal(): void {
        this.modalClosed.emit();
    }

    private _changeProductProperty(key: string, value: any, isJSON = false): void {
        this.auth.setProductProperty(this.product?.id, key, value, isJSON).subscribe({
            next: () => {
                this.toastr.success('Tag updated successfully');
                this.sharedService.refreshProductId.next({
                    action: 'edited',
                    productId: this.product?.id,
                });
                this.tagChanged.emit({ key, value });
            },
            error: (err) => {
                console.error(err);
                this.toastr.error('Error updating tag');
            }
        });
    }

    private _getTagList(): void {
        this.loadingTags = true;
        this.customerService.getTagList(this.product?.id).subscribe({
            next: (resp: any) => {
                console.log('Full API Response:', resp);
                console.log('Response type:', typeof resp);
                console.log('Response keys:', Object.keys(resp || {}));

                // Handle different response structures
                if (resp) {
                    // Check if response is wrapped in body property
                    const responseData = resp.body || resp;

                    this.tagGroups = Object.keys(responseData.types).map(groupName => ({
                        name: groupName,
                        tags: responseData.types[groupName]
                    }));
                    console.log('Using responseData.types converted to groups:', this.tagGroups);
                    this.tagGroupsUser = Object.keys(responseData.typesUser).map(groupName => ({
                        name: groupName,
                        tags: responseData.typesUser[groupName]
                    }));
                    console.log('Using responseData.typesUser converted to groups:', this.tagGroupsUser);
                } else {
                    console.log('Empty response received');
                    this.tagGroups = [];
                    this.tagGroupsUser = [];
                }

                console.log('Final tagGroups:', this.tagGroups);
                this.loadingTags = false;
            },
            error: (err) => {
                console.error('Error fetching tag list:', err);
                this.tagGroups = [];
                this.tagGroupsUser = [];
                this.loadingTags = false;
            }
        });
    }

    private _sanitizeYoutubeIframes(): void {
        this.sanitizedYoutubeIframes = [];
        if (this.product?.additionalTag?.includes('Youtube')) {
            return;
        }
        if (!this.product?.linked?.trim()?.split('\n')) {
            return;
        }
        for (const iframe of this.product?.linked?.trim()?.split('\n')) {
            if (iframe?.trim()?.startsWith('<iframe')) {
                this.sanitizedYoutubeIframes.push(this.sanitizeHTML(iframe));
            }
        }
    }

    public sanitizeHTML(html: string): any {
        return this.commonService.sanitizeHTML(html);
    }

    private _parseMapTag(mapTag: any): string[] {
        if (!mapTag) {
            return [];
        }

        // If it's already an array, return it
        if (Array.isArray(mapTag)) {
            return [...mapTag];
        }

        // If it's a string, try to parse it
        if (typeof mapTag === 'string') {
            const trimmed = mapTag.trim();

            // If it's empty, return empty array
            if (!trimmed) {
                return [];
            }

            // Try to parse as JSON array
            try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) {
                    return parsed;
                }
            } catch (e) {
                // If JSON parsing fails, treat as single string value
                console.log('Failed to parse mapTag as JSON, treating as single string:', trimmed);
            }

            // If it looks like an array string but JSON parsing failed, try manual parsing
            if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
                try {
                    // Remove brackets and split by comma, then clean up quotes
                    const content = trimmed.slice(1, -1);
                    const items = content.split(',').map(item =>
                        item.trim().replace(/^["']|["']$/g, '')
                    );
                    return items.filter(item => item.length > 0);
                } catch (e) {
                    console.log('Failed to manually parse array string:', trimmed);
                }
            }

            // Fallback: treat as single string value
            return [trimmed];
        }

        // For any other type, return empty array
        return [];
    }
}